let isLive = false
export const setIsLive=(val)=>{
    isLive = val
}
export const getIsLive=()=>{
    return isLive
}